import { useEffect, useState } from 'react';
import { getFavorites } from './favorites';

export function useFavorites() {
  const [list, setList] = useState(getFavorites());
  useEffect(() => {
    const update = () => setList(getFavorites());
    window.addEventListener('favorites-changed', update);
    window.addEventListener('storage', update);
    return () => {
      window.removeEventListener('favorites-changed', update);
      window.removeEventListener('storage', update);
    };
  }, []);
  return {
    list,
    has: (id) => list.some((f) => f.id === id),
    count: list.length,
  };
}
